// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_s5MwG","box":"index_box_jDytT","footer":"index_footer_R1jts"};